import {
  BranchModel,
  EnumEmployeeShiftState,
  EnumGenderType,
  EnumIcons,
  EnumMenuType,
  EnumReportType,
  EnumTempBranchRequestStatus,
  EnumUserAcces,
  EnumUserStatus,
  GenderTypeModel,
  MenuItem,
  PreferredTimeModel,
  ReportTypeModel,
  ShiftModel,
  ShiftPlanEmployee,
  ShiftPlanModel,
  TempBranchRequestStatusModel,
  UserAccessModel,
  UserModel,
  UserStatusModel,
  UserToggleAbility,
  WorkStateModel,
} from "./dataStructures";

export function currentDateFormat() {
  const df: string = "DD.MM.YYYY";
  return df;
}

export function getLanguage() {
  return false;
}

export function getUserRoleObject(type: EnumUserAcces) {
  const role: UserAccessModel | undefined = getUserRolesList().find(
    (x) => x.type === type
  );
  if (role === undefined) {
    return getUserRolesList()[0];
  }
  return role;
}

export function getUserRoleObjectForKey(key_id: string) {
  const role: UserAccessModel | undefined = getUserRolesList().find(
    (x) => x.key === key_id
  );
  if (role === undefined) {
    return getUserRolesList()[0];
  }
  return role;
}

export function getUserRoleObjectForName(disp_name: string) {
  const role: UserAccessModel | undefined = getUserRolesList().find(
    (x) => x.display_name === disp_name
  );
  if (role === undefined) {
    return getUserRolesList()[0];
  }
  return role;
}

export function getUserRolesList() {
  const isEnglish = getLanguage();
  const array_userRoles: UserAccessModel[] = [
    {
      type: EnumUserAcces.ADMIN,
      key: "admin",
      display_name: isEnglish ? "Admin" : "Administrator",
      id: "2",
      color_scheme: "text-gray-700 ring-gray-600/20 bg-gray-50",
    },
    {
      type: EnumUserAcces.SHIFT_PLANER,
      key: "shift_planner",
      display_name: isEnglish ? "Shift Planer" : "Schichtplaner",
      id: "3",
      color_scheme: "text-gray-700 ring-gray-600/20 bg-gray-50",
    },
    {
      type: EnumUserAcces.BRANCH_MANAGER,
      key: "branch_manager",
      display_name: isEnglish ? "Branch Manager" : "Filialleiter/Schichtleiter",
      id: "4",
      color_scheme: "text-gray-700 ring-gray-600/20 bg-gray-50",
    },
    {
      type: EnumUserAcces.TEAM_LEAD,
      key: "team_lead",
      display_name: isEnglish ? "Team Lead" : "Teamleiter",
      id: "5",
      color_scheme: "text-green-700 ring-green-600/20 bg-green-50",
    },
    {
      type: EnumUserAcces.TEMP_TEAM_LEAD,
      key: "team_lead",
      display_name: isEnglish ? "Team Lead" : "Teamleiter",
      id: "6",
      color_scheme: "text-green-700 ring-green-600/20 bg-green-50",
    },
    {
      type: EnumUserAcces.DEV,
      key: "dev",
      display_name: isEnglish ? "Developer" : "Entwickler",
      id: "7",
      color_scheme: "text-blue-700 ring-blue-600/20 bg-blue-50",
    },
    {
      type: EnumUserAcces.EMPLOYEE,
      key: "employee",
      display_name: isEnglish ? "Employee" : "Mitarbeiter",
      id: "8",
      color_scheme: "text-gray-700 ring-gray-600/20 bg-gray-50",
    },
  ];

  return array_userRoles;
}

export function getFormattedDate(date_: Date) {
  const formattedDate: string =
    "" + date_.getDay() + "-" + date_.getMonth() + "-" + date_.getFullYear();
  return formattedDate;
}

export function isModulePasswordUnswitchable(menu: EnumMenuType) {
  switch (menu) {
    case EnumMenuType.TEAM_LEAD_ATTENDANCE_LIST:
      return true;
    default:
      return false;
  }
}

export function createUserModelObj() {
  const user: UserModel = {
    user_id: "-1",
    employee_id: "",
    email_id: "",
    profile_pic_url: "",
    first_name: "",
    last_name: "",
    mobilePrefix: "",
    mobile: "",
    address: "",
    working_status: convertWorkStatusViaKey(""),
    user_city: "",
    user_state: "",
    user_zipcode: "",
    permanent_branch_id: "-1",
    permanant_branch: getBranchForId([], ""),
    role: getUserRoleObjectForKey("employee"),
    hourly_rate: 0,
    pref_time: createPrefTimeArray(),
    toggleAbility: getUserToggleEnabled(true),
    about_us: "",
    gender: getGenderType(EnumGenderType.MALE),
  };
  return user;
}

export function getMenuListForUserRole(userRole: EnumUserAcces) {
  switch (userRole) {
    case EnumUserAcces.DEV:
      return getAllMenusItems();
    case EnumUserAcces.ADMIN:
      const array_adminItems: MenuItem[] = [
        getMenuItemForMenuType(EnumMenuType.USERS),
        getMenuItemForMenuType(EnumMenuType.BRANCHES),
        getMenuItemForMenuType(EnumMenuType.SHIFTS),
        getMenuItemForMenuType(EnumMenuType.REPORTS),
        getMenuItemForMenuType(EnumMenuType.REPORT_BRANCH),
        getMenuItemForMenuType(EnumMenuType.REPORT_EMPLOYEE),
        getMenuItemForMenuType(EnumMenuType.REPORT_RAW),
      ];
      return array_adminItems;
    case EnumUserAcces.SHIFT_PLANER:
      const array_spItems: MenuItem[] = [
        getMenuItemForMenuType(EnumMenuType.SHIFT_PLANER_WORKSTATION),
      ];
      return array_spItems;
    case EnumUserAcces.BRANCH_MANAGER:
      const array_bmItems: MenuItem[] = [
        getMenuItemForMenuType(EnumMenuType.BRANCH_MANAGER_WORKSTATION),
      ];
      return array_bmItems;
    case EnumUserAcces.TEAM_LEAD:
      const array_tlItems: MenuItem[] = [
        getMenuItemForMenuType(EnumMenuType.TEAM_LEAD_ATTENDANCE_LIST),
        getMenuItemForMenuType(EnumMenuType.TEAM_LEAD_WORKSTATION),
        getMenuItemForMenuType(EnumMenuType.EMPLOYEE_SCHEDULE),
        getMenuItemForMenuType(EnumMenuType.EMPLOYEE_HISTORY_REPORT),
      ];
      return array_tlItems;
    case EnumUserAcces.EMPLOYEE:
      const array_empItems: MenuItem[] = [
        getMenuItemForMenuType(EnumMenuType.EMPLOYEE_SCHEDULE),
        getMenuItemForMenuType(EnumMenuType.EMPLOYEE_HISTORY_REPORT),
      ];
      return array_empItems;
    default:
      const tempItem_array: MenuItem[] = [
        {
          id: 0,
          title: "Unknown",
          icon: getSvgIcon(EnumIcons.Branches)?.string as string,
          menuType: EnumMenuType.UNKNOWN,
        },
      ];
      return tempItem_array;
  }
}

function getMenuItemForMenuType(type: EnumMenuType) {
  const array_items: MenuItem[] = getAllMenusItems();
  const sindex: number = array_items.findIndex((x) => x.menuType === type);
  if (sindex === -1) {
    const tempItem: MenuItem = {
      id: 0,
      title: "Unknown",
      icon: getSvgIcon(EnumIcons.Branches)?.string as string,
      menuType: EnumMenuType.UNKNOWN,
    };
    return tempItem;
  }

  return getAllMenusItems()[sindex];
}

function getAllMenusItems() {
  const isEnglish = getLanguage();
  const items: MenuItem[] = [
    {
      id: 1,
      title: isEnglish ? "Users" : "Mitarbeiter",
      icon: getSvgIcon(EnumIcons.Users)?.string as string,
      menuType: EnumMenuType.USERS,
    },
    {
      id: 2,
      title: isEnglish ? "Branches" : "Filialen",
      icon: getSvgIcon(EnumIcons.Branches)?.string as string,
      menuType: EnumMenuType.BRANCHES,
    },
    {
      id: 3,
      title: isEnglish
        ? "Report : Daily Branch"
        : "Berichte: Tagesbericht Filiale",
      icon: getSvgIcon(EnumIcons.Reports)?.string as string,
      menuType: EnumMenuType.REPORTS,
    },
    {
      id: 4,
      title: isEnglish ? "Shifts" : "Schichten",
      icon: getSvgIcon(EnumIcons.Calendar)?.string as string,
      menuType: EnumMenuType.SHIFTS,
    },
    {
      id: 5,
      title: isEnglish ? "Home" : "Start",
      icon: getSvgIcon(EnumIcons.Branches)?.string as string,
      menuType: EnumMenuType.TEAM_LEAD_ATTENDANCE_LIST,
    },
    {
      id: 6,
      title: isEnglish ? "Requests" : "Aussstehende Anfragen",
      icon: getSvgIcon(EnumIcons.Branches)?.string as string,
      menuType: EnumMenuType.TEAM_LEAD_WORKSTATION,
    },
    {
      id: 7,
      title: isEnglish ? "Work Station" : "Filial-/Schichtleitung Dashboard",
      icon: getSvgIcon(EnumIcons.Branches)?.string as string,
      menuType: EnumMenuType.BRANCH_MANAGER_WORKSTATION,
    },
    {
      id: 8,
      title: isEnglish ? "Work Station" : "Personalarbeitszeitplanung",
      icon: getSvgIcon(EnumIcons.Branches)?.string as string,
      menuType: EnumMenuType.SHIFT_PLANER_WORKSTATION,
    },
    {
      id: 9,
      title: isEnglish ? "Profile" : "Profil",
      icon: getSvgIcon(EnumIcons.Branches)?.string as string,
      menuType: EnumMenuType.PROFILE,
    },
    {
      id: 10,
      title: isEnglish ? "My Schedule" : "Mein Arbeitsplan",
      icon: getSvgIcon(EnumIcons.Branches)?.string as string,
      menuType: EnumMenuType.EMPLOYEE_SCHEDULE,
    },
    {
      id: 11,
      title: isEnglish ? "My Report" : "Meine Berichte",
      icon: getSvgIcon(EnumIcons.Branches)?.string as string,
      menuType: EnumMenuType.EMPLOYEE_HISTORY_REPORT,
    },
    {
      id: 12,
      title: isEnglish ? "Report: All Employees" : "Berichte: Mitarbeiter",
      icon: getSvgIcon(EnumIcons.Reports)?.string as string,
      menuType: EnumMenuType.REPORT_EMPLOYEE,
    },
    {
      id: 13,
      title: isEnglish ? "Report: All Branches" : "Berichte: Alle Filialen",
      icon: getSvgIcon(EnumIcons.Reports)?.string as string,
      menuType: EnumMenuType.REPORT_BRANCH,
    },
    {
      id: 14,
      title: isEnglish ? "Report: Raw Data" : "Bericht: Rohdaten",
      icon: getSvgIcon(EnumIcons.Reports)?.string as string,
      menuType: EnumMenuType.REPORT_RAW,
    },
  ];
  return items;
}

function getSvgIcon(icon: EnumIcons) {
  const icons: { string: string; EnumIcons: EnumIcons }[] = [
    {
      string:
        "M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25",
      EnumIcons: EnumIcons.Branches,
    },
    {
      string:
        "M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z",
      EnumIcons: EnumIcons.Users,
    },
    {
      string:
        "M2.25 12.75V12A2.25 2.25 0 014.5 9.75h15A2.25 2.25 0 0121.75 12v.75m-8.69-6.44l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z",
      EnumIcons: EnumIcons.Projects,
    },
    {
      string:
        "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5",
      EnumIcons: EnumIcons.Calendar,
    },
    {
      string:
        "M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75",
      EnumIcons: EnumIcons.Documents,
    },
    {
      string:
        "M10.5 6a7.5 7.5 0 107.5 7.5h-7.5V6z M13.5 10.5H21A7.5 7.5 0 0013.5 3v7.5z",
      EnumIcons: EnumIcons.Reports,
    },
    {
      string:
        "M50,24H6.83L27.41,3.41a2,2,0,0,0,0-2.82,2,2,0,0,0-2.82,0l-24,24a1.79,1.79,0,0,0-.25.31A1.19,1.19,0,0,0,.25,25c0,.07-.07.13-.1.2l-.06.2a.84.84,0,0,0,0,.17,2,2,0,0,0,0,.78.84.84,0,0,0,0,.17l.06.2c0,.07.07.13.1.2a1.19,1.19,0,0,0,.09.15,1.79,1.79,0,0,0,.25.31l24,24a2,2,0,1,0,2.82-2.82L6.83,28H50a2,2,0,0,0,0-4Z",
      EnumIcons: EnumIcons.Back,
    },
  ];

  const defaultIcon: { string: string; EnumIcons: EnumIcons } = icons[4];
  if (icons.find((x) => x.EnumIcons === icon) !== undefined) {
    return icons.find((x) => x.EnumIcons === icon);
  }

  return defaultIcon;
}

export function convertWorkStatus(status: EnumEmployeeShiftState) {
  const isEnglish = getLanguage();
  switch (status) {
    case EnumEmployeeShiftState.WORKING: {
      const item: WorkStateModel = {
        status: status,
        display_name: isEnglish ? "Working" : "Arbeitet",
        color_scheme: "text-green-700 ring-green-600/20 bg-green-50",
      };
      return item;
    }

    case EnumEmployeeShiftState.ON_BREAK: {
      const item: WorkStateModel = {
        status: status,
        display_name: isEnglish ? "On Break" : "In der Pause",
        color_scheme: "text-red-700 ring-red-600/20 bg-red-50",
      };
      return item;
    }

    case EnumEmployeeShiftState.SHIFT_ENDED: {
      const item: WorkStateModel = {
        status: status,
        display_name: isEnglish ? "Shift Ended" : "Schicht beendet",
        color_scheme: "text-yellow-700 ring-yellow-600/20 bg-yellow-50",
      };
      return item;
    }

    default: {
      const item: WorkStateModel = {
        status: status,
        display_name: isEnglish ? "Not Available" : "Nicht gestartet",
        color_scheme: "text-gray-700 ring-gray-600/20 bg-gray-50",
      };
      return item;
    }
  }
}

export function createBranch() {
  const unknownBranch: BranchModel = {
    branch_id: "-1",
    name: "",
    address: "",
    phone: "",
    contact_name: "",
    contact_email: "",
    contact_phone: "",
  };
  return unknownBranch;
}

export function noneBranchObject() {
  const unknownBranch: BranchModel = {
    branch_id: "-1",
    name: getLanguage() ? "None" : "Keine Auswahl",
    address: "",
    phone: "",
    contact_name: "",
    contact_email: "",
    contact_phone: "",
  };
  return unknownBranch;
}

export function noneShiftObject() {
  const unknownBranch: ShiftModel = {
    shift_id: "-1",
    title: getLanguage() ? "None" : "Keine Auswahl",
    start_time: "",
    end_time: "",
  };
  return unknownBranch;
}

export function getBranchForId(
  array_branches: BranchModel[],
  branch_id: string
) {
  const branch: BranchModel | undefined = array_branches.find(
    (x) => x.branch_id === branch_id
  );
  if (branch === undefined) {
    const unknownBranch: BranchModel = {
      branch_id: "0",
      name: "",
      address: "",
      phone: "",
      contact_name: "",
      contact_email: "",
      contact_phone: "",
    };
    return unknownBranch;
  }
  return branch;
}

export function convertWorkStatusViaName(dis_name: string) {
  const work_status: UserStatusModel | undefined = getUserStatusList().find(
    (x) => x.display_name === dis_name
  );
  if (work_status === undefined) {
    return getUserStatusList()[0];
  }
  return work_status;
}

export function convertWorkStatusViaKey(key: string) {
  const work_status: UserStatusModel | undefined = getUserStatusList().find(
    (x) => x.key === key
  );
  if (work_status === undefined) {
    return getUserStatusList()[0];
  }
  return work_status;
}

export function getUserStatusList() {
  const isEnglish = getLanguage();
  const array_working_status: UserStatusModel[] = [
    {
      status: EnumUserStatus.UNKNOWN,
      display_name: isEnglish ? "Unknown" : "Nicht bekannt",
      key: "unknown",
      color_scheme: "text-gray-700 ring-gray-600/20 bg-gray-50",
      id: "1",
    },
    {
      status: EnumUserStatus.WORKING,
      display_name: isEnglish ? "Working" : "Arbeitet",
      color_scheme: "text-green-700 ring-green-600/20 bg-green-50",
      key: "working",
      id: "2",
    },
    {
      status: EnumUserStatus.ON_VACATION,
      display_name: isEnglish ? "On Vacation" : "Urlaub",
      color_scheme: "text-red-700 ring-red-600/20 bg-red-50",
      key: "vacation",
      id: "3",
    },
    {
      status: EnumUserStatus.SICK,
      display_name: isEnglish ? "Sick" : "Krank",
      color_scheme: "text-red-700 ring-red-600/20 bg-red-50",
      key: "sick",
      id: "4",
    },
    {
      status: EnumUserStatus.FREE,
      display_name: isEnglish ? "Free" : "Frei",
      color_scheme: "text-yellow-700 ring-yellow-600/20 bg-yellow-50",
      key: "free",
      id: "5",
    },
    {
      status: EnumUserStatus.RESIGNED,
      display_name: isEnglish ? "Resigned" : "Gekündigt",
      color_scheme: "text-gray-700 ring-gray-600/20 bg-gray-50",
      key: "resigned",
      id: "6",
    },
  ];
  return array_working_status;
}

export function getTempBranchStatusElement(
  status: EnumTempBranchRequestStatus
) {
  const array_status: TempBranchRequestStatusModel[] = getTLRequestStatusList();
  const statusModel: TempBranchRequestStatusModel | undefined =
    array_status.find((x) => x.status === status);
  if (statusModel === undefined) {
    return array_status[0];
  }
  return statusModel;
}

function getTLRequestStatusList() {
  const array_status_: TempBranchRequestStatusModel[] = [
    {
      status: EnumTempBranchRequestStatus.PENDING,
      key: "pending",
      display_name: "Pending Request",
      color_scheme: "text-gray-700 ring-gray-600/20 bg-gray-50",
    },
    {
      status: EnumTempBranchRequestStatus.ACCEPTED,
      key: "accepted",
      display_name: "Acccepted",
      color_scheme: "text-green-700 ring-green-600/20 bg-green-50",
    },
    {
      status: EnumTempBranchRequestStatus.REJECTED,
      key: "pending",
      display_name: "Rejected",
      color_scheme: "text-red-700 ring-red-600/20 bg-red-50",
    },
    {
      status: EnumTempBranchRequestStatus.UNKNWON,
      key: "unknown",
      display_name: "Unknown",
      color_scheme: "text-red-700 ring-red-600/20 bg-red-50",
    },
  ];

  return array_status_;
}

export function createEmptyShiftObject() {
  const shift: ShiftModel = {
    shift_id: "-1",
    title: "",
    start_time: "",
    end_time: "",
  };
  return shift;
}

export function createShiftPlan(
  plan_date: Date,
  branch: BranchModel,
  shift: ShiftModel
) {
  const shiftPlanObj: ShiftPlanModel = {
    branch: branch,
    date: plan_date,
    shift: shift,
    array_employees: [],
    branch_id: "-1",
    shift_id: "-1",
    team_lead_id: "-1",
    log_id: "-1",
  };
  return shiftPlanObj;
}

export function createShiftPlanEmpoyee(user: UserModel, shift: ShiftModel) {
  let shiftPlanEmpEle: ShiftPlanEmployee = {
    user: user,
    current_state: EnumEmployeeShiftState.UNKNOWN,
    array_shift_entries: [],
  };
  if (shift.start_time !== null || shift.start_time !== undefined) {
    shiftPlanEmpEle.employee_start_at = shift.start_time;
  }
  if (shift.end_time !== null || shift.end_time !== undefined) {
    shiftPlanEmpEle.employee_end_at = shift.end_time;
  }
  return shiftPlanEmpEle;
}

export function pageIsSearchable(menuType: EnumMenuType) {
  switch (menuType) {
    case EnumMenuType.USERS: {
      return true;
    }
    case EnumMenuType.BRANCHES: {
      return true;
    }
    case EnumMenuType.REPORTS: {
      return true;
    }
    case EnumMenuType.TEAM_LEAD_WORKSTATION: {
      return true;
    }
    case EnumMenuType.TEAM_LEAD_ATTENDANCE_LIST: {
      return true;
    }
    case EnumMenuType.BRANCH_MANAGER_WORKSTATION: {
      return true;
    }
    case EnumMenuType.REPORT_DETAIL: {
      return true;
    }

    case EnumMenuType.SETTINGS: {
      return false;
    }
    case EnumMenuType.USER_DETAIL: {
      return false;
    }
    case EnumMenuType.SHIFT_PLANER_WORKSTATION: {
      return false;
    }

    case EnumMenuType.SHIFTS: {
      return false;
    }
    default: {
      return false;
    }
  }
}

export function createPrefTimeArray() {
  const isEnglish = getLanguage();
  const array: PreferredTimeModel[] = [
    {
      day_display: isEnglish ? "Monday" : "Montag",
      start_time: "",
      end_time: "",
      day_key: "mon",
    },
    {
      day_display: isEnglish ? "Tuesday" : "Dienstag",
      start_time: "",
      end_time: "",
      day_key: "tue",
    },
    {
      day_display: isEnglish ? "Wednesday" : "Mittwoch",
      start_time: "",
      end_time: "",
      day_key: "wed",
    },
    {
      day_display: isEnglish ? "Thrusday" : "Donnerstag",
      start_time: "",
      end_time: "",
      day_key: "thr",
    },
    {
      day_display: isEnglish ? "Friday" : "Freitag",
      start_time: "",
      end_time: "",
      day_key: "fri",
    },
    {
      day_display: isEnglish ? "Saturday" : "Samstag",
      start_time: "",
      end_time: "",
      day_key: "sat",
    },
    {
      day_display: isEnglish ? "Sunday" : "Sonntag",
      start_time: "",
      end_time: "",
      day_key: "sun",
    },
  ];
  return array;
}

export function getUserToggleArray() {
  const isEnglish = getLanguage();
  const array_toggles: UserToggleAbility[] = [
    {
      key: "yes",
      display_name: isEnglish ? "Enabled" : "Aktiviert",
    },
    {
      key: "no",
      display_name: isEnglish ? "Disabled" : "Gesperrt",
    },
  ];
  return array_toggles;
}

export function getUserToggleEnabled(isEnabled: boolean) {
  const array_toggles: UserToggleAbility[] = getUserToggleArray();
  if (isEnabled) {
    return array_toggles[0];
  }
  return array_toggles[1];
}

export function getUserToggleWithKey(key: string) {
  const array_toggles: UserToggleAbility[] = getUserToggleArray();
  const index: number = array_toggles.findIndex((x) => x.key === key);
  if (index !== -1) {
    return array_toggles[index];
  }
  const dispIndex: number = array_toggles.findIndex(
    (x) => x.display_name === key
  );
  if (dispIndex !== -1) {
    return array_toggles[dispIndex];
  }
  return array_toggles[0];
}

export function getReportType(key: string | EnumReportType) {
  const array_types = getReportTypesList();
  if (typeof key === "string") {
    const index: number = array_types.findIndex(
      (x) => x.key === key || x.display_name === key
    );
    if (index !== -1) {
      return array_types[index];
    }
  } else {
    const index: number = array_types.findIndex((x) => x.type === key);
    if (index !== -1) {
      return array_types[index];
    }
  }

  return {
    type: EnumReportType.UNKNOWN,
    key: "unknown",
    display_name: "Unknown Type",
  };
}

export function getReportTypesList() {
  const array_types: ReportTypeModel[] = [
    {
      type: EnumReportType.DAILY,
      key: "daily",
      display_name: "Daily Reports",
    },
    {
      type: EnumReportType.WEEKLY,
      key: "weekly",
      display_name: "Weekly Reports",
    },
    {
      type: EnumReportType.MONTHLY,
      key: "monthly",
      display_name: "Monthly Reports",
    },
  ];
  return array_types;
}

export function getGenderTypesList() {
  const array_types: GenderTypeModel[] = [
    {
      type: EnumGenderType.MALE,
      key: "male",
      display_name: "M",
    },
    {
      type: EnumGenderType.FEMALE,
      key: "female",
      display_name: "W",
    },
  ];
  return array_types;
}

export function getGenderType(key: string | EnumGenderType) {
  const array_types = getGenderTypesList();
  if (typeof key === "string") {
    const index: number = array_types.findIndex(
      (x) => x.key === key || x.display_name === key
    );
    if (index !== -1) {
      return array_types[index];
    }
  } else {
    const index: number = array_types.findIndex((x) => x.type === key);
    if (index !== -1) {
      return array_types[index];
    }
  }

  return {
    type: EnumGenderType.UNKNOWN,
    key: "unknown",
    display_name: "Unknown Type",
  };
}
